import { render, staticRenderFns } from "./WordpressButton.vue?vue&type=template&id=27e2c9c1&scoped=true&"
import script from "./WordpressButton.vue?vue&type=script&lang=js&"
export * from "./WordpressButton.vue?vue&type=script&lang=js&"
import style0 from "./WordpressButton.vue?vue&type=style&index=0&id=27e2c9c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e2c9c1",
  null
  
)

export default component.exports